var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTrophyGold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.635 2.72165C9.67097 2.65633 9.72381 2.60185 9.78801 2.56391C9.85221 2.52597 9.92542 2.50595 10 2.50595C10.0746 2.50595 10.1478 2.52597 10.212 2.56391C10.2762 2.60185 10.329 2.65633 10.365 2.72165L12.825 7.39165C12.8837 7.49979 12.9655 7.5936 13.0648 7.66634C13.164 7.73908 13.2781 7.78895 13.3988 7.81237C13.5196 7.83579 13.6441 7.83218 13.7633 7.8018C13.8825 7.77142 13.9935 7.71502 14.0883 7.63665L17.6525 4.58332C17.7209 4.52767 17.8052 4.49517 17.8933 4.49049C17.9814 4.48581 18.0686 4.50919 18.1426 4.55728C18.2165 4.60536 18.2733 4.67566 18.3047 4.75806C18.3361 4.84046 18.3406 4.93071 18.3175 5.01582L15.9558 13.5542C15.9076 13.7289 15.8038 13.8831 15.66 13.9935C15.5162 14.1039 15.3404 14.1644 15.1592 14.1658H4.84166C4.66028 14.1646 4.48426 14.1041 4.34032 13.9937C4.19639 13.8834 4.09241 13.729 4.04416 13.5542L1.68333 5.01665C1.66021 4.93155 1.66468 4.8413 1.69611 4.7589C1.72755 4.6765 1.78432 4.60619 1.85825 4.55811C1.93218 4.51003 2.01946 4.48664 2.10753 4.49132C2.1956 4.496 2.27991 4.52851 2.34833 4.58415L5.91166 7.63749C6.0065 7.71586 6.1175 7.77226 6.23672 7.80264C6.35593 7.83302 6.48039 7.83663 6.60116 7.8132C6.72194 7.78978 6.83603 7.73991 6.93524 7.66717C7.03446 7.59443 7.11633 7.50062 7.175 7.39249L9.635 2.72165Z",
    stroke: "var(--stroke-0, #F0B100)",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.16667 17.5H15.8333",
    stroke: "var(--stroke-0, #F0B100)",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrophyGold);
export default __webpack_public_path__ + "static/media/icon-trophy-gold.5ae78152276f978321991c72caf2cfa1.svg";
export { ForwardRef as ReactComponent };